import React from 'react';
import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { UserPlus, Search, TrendingUp } from 'lucide-react';

export const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: UserPlus,
      title: t('step1Title'),
      description: t('step1Desc'),
      number: '01'
    },
    {
      icon: Search,
      title: t('step2Title'),
      description: t('step2Desc'),
      number: '02'
    },
    {
      icon: TrendingUp,
      title: t('step3Title'),
      description: t('step3Desc'),
      number: '03'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-purple-50" data-testid="how-it-works-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-4">{t('howItWorks')}</h2>
        
        <div className="grid md:grid-cols-3 gap-8 mt-12">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <Card key={index} className="relative overflow-hidden transition-all hover:shadow-xl" data-testid={`step-card-${index}`}>
                <div className="absolute top-0 right-0 text-8xl font-bold text-purple-50 -mr-4 -mt-4">
                  {step.number}
                </div>
                <CardHeader>
                  <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                    <Icon className="h-8 w-8 text-purple-600" />
                  </div>
                  <CardTitle className="text-xl">{step.title}</CardTitle>
                </CardHeader>
                <CardContent>
                  <p className="text-gray-600">{step.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
